import {SEND_COMMAND_SUCCESS} from "../../reducers/cleaningControlReducer";


export const sendCommandSuccess = (namespace) =>{
    return {
        type: namespace + SEND_COMMAND_SUCCESS,
        payload: {}
    }
}